import React from 'react';
import { Component } from 'react';
import { connect } from 'react-redux'
import RaisedButton from 'material-ui/RaisedButton';
import { resetPassword, setUserPasswordResetSuccess } from '../../../redux/actions/userAction';

import { withRouter } from 'react-router'
import logo from '../../../assets/img/application_logo.png';
import TextField from 'material-ui/TextField';
class ForgotPassword extends Component {
    constructor(props) {
        super(props);

        this.state = {
            user_email: this.props.user.user_email ? this.props.user.user_email : '',
        }
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidUpdate(prevProps) {
        if(this.props.user.user_password_success === true) {
            this.props.setUserPasswordResetSuccess(false);
            this.props.history.push('/login');
        }
    }

    handleSubmit(e) {
        if(e) {
            e.preventDefault();
        }

        this.props.resetPassword(this.props.clientPath + '/api/user/action/resetPassword', {user_email: this.state.user_email});
    }

    componentDidMount() {
        document.querySelector('title').innerHTML = 'MijnDP - Wachtwoord vergeten';
    }


    render() {
        return (
            <div>

                <div className="login-wrapper">
                    <div className="card">
                        <div className="card__body">
                            <div className="login-fields">
                                <img alt={"DP Logo"} src={logo} />
            <form onSubmit={this.handleSubmit}>


                <p style={{textAlign: 'center'}}>
                    Wachtwoord vergeten? {"\n"}
                    Vul uw e-mailadres in om een nieuw {"\n"}
                    wachtwoord aan te vragen.
                    {"\n"}

                </p>
                <p style={{textAlign: 'center'}}>
                    Hulp nodig? <br /> <a style={{color: 'black'}} href="callto:0172 488 388">Bel Duijvelaar:  0172 488 388</a>
                </p>

                <TextField
                        id="email"
                        floatingLabelText="E-mailadres"
                        fullWidth={true}
                        type="text"

                        onChange={(e) => this.setState({user_email: e.target.value})}

                    />


                <div className="pt20">
                    <RaisedButton onClick={() => this.handleSubmit()} label="Reset wachtwoord" primary={true} fullWidth={true}/>
                </div>


            </form>
            </div>
            </div>
            </div>
            </div>
            </div>


        )
    }
}



function mapStateToProps(state, ownProps) {

    return {
        user: state.UserReducer,
        clientPath: state.ClientPathReducer.clientPath
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        resetPassword: (url, postData) => dispatch(resetPassword(url, postData)),
        setUserPasswordResetSuccess : bool => dispatch(setUserPasswordResetSuccess(bool))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ForgotPassword))



// WEBPACK FOOTER //
// ./src/components/Login/ForgotPassword/index.js